var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6875 12C21.6875 6.64844 17.3516 2.3125 12 2.3125C6.64844 2.3125 2.3125 6.64844 2.3125 12C2.3125 16.8352 5.85508 20.843 10.4863 21.5703V14.8004H8.02539V12H10.4863V9.86563C10.4863 7.43789 11.9316 6.09687 14.1453 6.09687C15.2055 6.09687 16.3141 6.28594 16.3141 6.28594V8.66875H15.0922C13.8891 8.66875 13.5137 9.41562 13.5137 10.1816V12H16.2004L15.7707 14.8004H13.5137V21.5703C18.1449 20.843 21.6875 16.8352 21.6875 12Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_25"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/FacebookIcon.101d4c5448f62cef85f2bcf44b710eb2.svg";
export { ForwardRef as ReactComponent };